import { Button } from "../../../../shared/components/ui/Button";
import { FormField } from "../../../../shared/components/forms/FormField";
import { useLifeguardPreLoginForm } from "./useLifeguardPreLoginForm";
import type { LifeguardPreLoginFormProps } from "./LifeguardPreLoginForm.types";

export const LifeguardPreLoginForm: React.FC<LifeguardPreLoginFormProps> = ({
  onPreLogin,
  isSubmitting,
}) => {
  const { form, onSubmit } = useLifeguardPreLoginForm({ onPreLogin });
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  return (
    <div className="flex flex-col gap-4 w-full max-w-sm">
      <h1 className="text-2xl font-bold">Salvavidas</h1>

      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        {/* Cédula */}
        <FormField
          type="input"
          label="Cédula de ciudadanía"
          required
          inputProps={{
            type: "text",
            placeholder: "Cédula de ciudadanía",
            ...register("citizenship_number"),
          }}
          error={errors.citizenship_number?.message}
        />

        {/* Submit */}
        <Button type="submit" disabled={!isValid || isSubmitting}>
          {isSubmitting ? "Verificando..." : "Continuar"}
        </Button>
      </form>
    </div>
  );
};

